module.exports = __webpack_public_path__ + "assets/images/pages/hearthy/hearthy-2.png?cf4465cf";